document.querySelectorAll( '.b-text-card' ).forEach( ( block ) => {

    /////////////////////
    // BLOCK CODE HERE //
    /////////////////////

} );
    